<div [innerHTML]="html | sharedSafe: 'html'" class="user-html-content n1-copyable">
  <!-- Html Markup goes here -->
</div>
